import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table, TableColumn as Column } from 'lp-components';
import { connect } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { ACCESS_LOAN_URL, CREDIT_PORTAL_URL, WIZARD_URL, PRE_QUALIFICATION_INFORMATION_REQUIRED_URL, Button, H1, P, formatISODateStringAsUSMonthDayYear, getFullName, } from 'shared';
import * as actions from '../actions';
import { selectors } from '../reducer';
import { getContinuablePrequalifications } from '../utils';
function ApplicationFound({ personalInfo, prequalifications, setLenderReferenceId, setPractice, setPrequalification, setPendingDecisionDetails, setLenderName, }) {
    const history = useHistory();
    const continuablePrequalifications = getContinuablePrequalifications(prequalifications);
    if (continuablePrequalifications.length === 0)
        return _jsx(Redirect, { to: CREDIT_PORTAL_URL });
    const { firstName, lastName } = personalInfo;
    const totalPrequalifications = continuablePrequalifications.length;
    const totalPrequalificationsPlural = totalPrequalifications > 1 ? 's' : '';
    const navigateToNextView = (prequalification) => {
        const { applicationStatus, lenderNextStepUrl, lenderRequestReferenceId, location, pendingDecisionDetails, } = prequalification;
        setPrequalification(prequalification);
        setPractice(location);
        setLenderReferenceId(lenderRequestReferenceId);
        setPendingDecisionDetails(pendingDecisionDetails);
        const offers = prequalification.offers ? prequalification.offers : [];
        const offerToUse = offers.find((offer) => offer.offerType !== 'not_prequalified');
        if (offerToUse && offerToUse.serviceProviderName) {
            const lenderName = offerToUse.serviceProviderName;
            setLenderName(lenderName);
        }
        else {
            setLenderName('');
        }
        if (applicationStatus === 'prequalified') {
            history.push({
                pathname: WIZARD_URL,
                state: {
                    step: 'PRE-QUALIFICATION',
                    fromFindMyApp: true,
                },
            });
        }
        else if (applicationStatus === 'pending_approval') {
            history.push({
                pathname: ACCESS_LOAN_URL,
                state: {
                    lenderNextStepUrl,
                    modalType: 'no-modal',
                    fromFindMyApp: true,
                    applicationStatus,
                },
            });
        }
        else if (applicationStatus === 'pending') {
            history.push(PRE_QUALIFICATION_INFORMATION_REQUIRED_URL);
        }
        else {
            throw new Error(`ERROR: unknown API application status: ${applicationStatus}`);
        }
    };
    return (_jsx("div", { className: "action-result-container", children: _jsxs("div", { className: "main-content min-height-600", children: [_jsx("header", { children: _jsxs(H1, { variant: "headline-medium", children: [totalPrequalifications, " Application", totalPrequalificationsPlural, " Found"] }) }), _jsxs(P, { bold: true, children: ["We have found the following existing application", totalPrequalificationsPlural, " for ", firstName, " ", lastName, ":"] }), _jsx(AllCreditApplications, { onSelect: navigateToNextView, applicant: personalInfo, prequalifications: continuablePrequalifications }), _jsx(P, { bold: true, children: "Please click \"CONTINUE\" to complete your application." })] }) }));
}
function mapStateToProps(state) {
    return {
        personalInfo: selectors.personalInfo(state),
        prequalifications: selectors.prequalifications(state),
    };
}
const mapDispatchToProps = {
    setLenderReferenceId: actions.setLenderReferenceId,
    setPractice: actions.setPractice,
    setPrequalification: actions.setPrequalification,
    setPendingDecisionDetails: actions.setPendingDecisionDetails,
    setLenderName: actions.setLenderName,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(ApplicationFound);
function AllCreditApplications({ applicant, onSelect, prequalifications, }) {
    const ApplyButton = ({ data }) => (_jsx("td", { className: "action", children: _jsx(Button, { className: "button-warn-outline", onClick: () => onSelect(data), type: "button", children: "CONTINUE" }) }));
    return (_jsxs(Table, { className: "result-table", data: prequalifications, children: [_jsx(Column, { name: "name", label: "Name", valueGetter: () => getFullName(applicant) }), _jsx(Column, { name: "location", label: "Location", valueGetter: ({ location }) => location.name }), _jsx(Column, { name: "applicationOpenedAt", label: "Date", format: (applicationOpenedAt) => formatISODateStringAsUSMonthDayYear(applicationOpenedAt) }), _jsx(Column, { name: "action", label: "", component: ApplyButton })] }));
}
